/**
 * 文本消息过长 - 展开
 */
import { inObjectValues } from '@/utils'
import { HOST } from '@/constants/message'

let textHeightMax = 0
const LINE_COUNT_MAX = 7
const PADDING = 16
const LINE_HEIGHT = 24

export default {
    props: {
        host: {
            type: String,
            required: true,
            validator (value) {
                return inObjectValues(HOST, value)
            }
        }
    },
    data () {
        return {
            textHeight: -1,
            isExpand: true
        }
    },
    computed: {
        isService () {
            return this.host === HOST.SERVICE
        },
        isBeyoungLimitLine () {
            // + 0.1 为了不受误差影响
            return this.textHeight > textHeightMax + 0.1
        }
    },
    methods: {
        toggleExpand () {
            this.isExpand = !this.isExpand
        }
    },
    mounted () {
        const textDom = this.$refs.text
        if (textDom) {
            this.textHeight = textDom.offsetHeight
        }
        textHeightMax = parseFloat(((LINE_COUNT_MAX * LINE_HEIGHT) + PADDING).toFixed(3))
    }
}
